<template>
  <permission-form :permission="newPermission"></permission-form>
</template>

<script>
import PermissionForm from './permissionForm'
import {Permission} from '../../../object'

export default {
  name: 'NewPermission',
  components: {PermissionForm},
  data: () => ({
    newPermission: new Permission()
  })
}
</script>

<style scoped>

</style>
